import { Checkbox } from 'antd';
import { useState } from 'react';
import { useCalledClient } from '../../../../api/1688-delivery/hooks';

export function CalledCheckbox(data) {
    const [value, setValue] = useState(data.data.isCalled);
    const { mutate, isLoading } = useCalledClient();

    const onChange = (e) => {
        setValue(e.target.checked);
        mutate(data.data.trackCode);
    };

    return <Checkbox defaultChecked={data.data.isCalled} checked={value} onChange={onChange} />;
}
